// extracted by mini-css-extract-plugin
export default {"meetingStatus":"BC1ob_","button":"_u12vS","buttonDisabled":"Qeg09f","meetingText":"Fw6AoX"};